var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('motlet-neo',{attrs:{"options":_vm.motletOptions},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var props = ref.props;
return [_c('line-chart',{attrs:{"settings":_vm.settings,"motlet":props.motlet,"store-name":_vm.storeName,"active-increment":_vm.activeIncrement}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }